export const getInitialState = (args) => {
    const { defaultValue = [] } = args;
    return {
        active: false,
        innerValue: defaultValue,
        quickSearch: '',
    };
};
export const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_ACTIVE': {
            const { active } = action.payload;
            return Object.assign(Object.assign({}, state), { active });
        }
        case 'SET_INNER_VALUE': {
            const { innerValue } = action.payload;
            return Object.assign(Object.assign({}, state), { innerValue });
        }
        case 'SET_QUICK_SEARCH': {
            const { quickSearch } = action.payload;
            return Object.assign(Object.assign({}, state), { quickSearch });
        }
        case 'SET_QUICK_SEARCH_TIMER': {
            const { quickSearchTimer } = action.payload;
            return Object.assign(Object.assign({}, state), { quickSearchTimer });
        }
        case 'SET_CONTROL_RECT': {
            const { controlRect } = action.payload;
            return Object.assign(Object.assign({}, state), { controlRect });
        }
        default: {
            return state;
        }
    }
};
